import { Component, OnInit } from '@angular/core';
import { ManpowerrecruitmentService } from 'src/app/services/manpowerrecruitment.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { TokenService } from 'src/app/services/token.service';
import { ExcelexportService } from 'src/app/services/excelexport.service';

@Component({
  selector: 'app-new-hires-view',
  templateUrl: './new-hires-view.component.html',
  styleUrls: ['./new-hires-view.component.css']
})
export class NewHiresViewComponent implements OnInit {

  Requests: any[] = [];
  currentUser: any;
  email: string = "";

  // Drawer visibility states
  ViewManpowerRequestVisible: boolean = false;
  ViewManpowerRecruitment: boolean = false;

  // Selected record for drawers
  UpdateRequest: any = {};

  constructor(
    private manpowerService: ManpowerrecruitmentService,
    private notification: NotificationService,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.loadRecords();
  }

  // ===========================
  // STATUS BADGE COLOR
  // ===========================
  getStatusColor(status: string): string { 
    switch (status) {
      case "New": return 'badge badge-info';
      case "Active": return 'badge badge-primary';
      case "Approved": return 'badge badge-success';
      case "Rejected": return 'badge badge-danger';
      default: return 'badge badge-warning';
    }
  }

  // ===========================
  // LOAD NEW HIRE RECORDS
  // ===========================
  async loadRecords() {
    this.currentUser = this.tokenService.getInfo();
    this.email = this.currentUser.profile.email;

    try {
      let result = await this.manpowerService.newHires().toPromise();
      if (result.requestSuccessful) {
        this.Requests = result.responseData;
      } else {
        this.notification.sendMessage({
          message: result.message,
          type: NotificationType.error
        });
      }
    } catch (e: any) {
      this.notification.sendMessage({
        message: e.error?.message ?? "Unable to load records",
        type: NotificationType.error
      });
    }
  }

  // ===========================
  // OPEN NEW HIRE DETAILS DRAWER
  // ===========================
  open(data: any) {
    this.UpdateRequest = data;
    this.ViewManpowerRequestVisible = true;
  }

  // ===========================
  // OPEN ONBOARDING DETAILS DRAWER
  // ===========================
  openRecruitment(data: any) {
    this.UpdateRequest = data;
    this.ViewManpowerRecruitment = true;
  }

  // ===========================
  // CLOSE ANY DRAWER
  // ===========================
  close() {
    this.ViewManpowerRequestVisible = false;
    this.ViewManpowerRecruitment = false;
  }

  // ===========================
  // PRINT NEW HIRE DETAILS
  // ===========================
  print(filename: string, section: string) {
    const printContents = document.getElementById(section)?.innerHTML;
    const popupWin = window.open('', '_blank', 'width=1200,height=900');

    popupWin?.document.open();
    popupWin?.document.write(`
      <html>
      <head>
        <title>${filename}</title>
        <style>
          @media print {
            body { -webkit-print-color-adjust: exact; }
          }
        </style>
      </head>
      <body onload="window.print(); window.close()">
        ${printContents}
      </body>
      </html>
    `);
    popupWin?.document.close();
  }

  // ===========================
  // PRINT ONBOARDING DETAILS
  // ===========================
  prints(filename: string, section: string) {
    this.print(filename, section);
  }
downloadExcel() {
  

  const exportData: Partial<object>[] = this.Requests.map(x => ({
    Reference: x.reference,
    RequestDate: x.createdDate,
    RequesterName: x.requesterName,
    RequesterDesignation: x.requesterDesignation,
    RequesterFunction: x.requesterFunction,
    RequesterUnit: x.requesterUnit,
    JobTitle: x.jobTitle,
    Location: x.location,

    VacancyStatus: x.vacancyStatus,

   
    RecruitmentCloseDate: x.recruitmentCloseDate,
    RecruitmentCloseMessage: x.recruitmentCloseMessage,

    OnHoldStartDate: x.onHoldStartDate,
    OnHoldMessage: x.onHoldMessage,

    AssumptionDate: x.assumptionDate,
    TimeOfHire: x.timeOfHire,
  }));

  ExcelexportService.exportArrayToExcel(exportData, 'New Hires');
}

}
